function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 0c8.83 0 16 7.17 16 16s-7.17 16-16 16S0 24.83 0 16 7.17 0 16 0zM5.338 23.026c2.92-2.209 6.644-3.534 10.699-3.534 4.054 0 7.779 1.325 10.698 3.534-2.29 3.477-6.228 5.774-10.698 5.774-4.47 0-8.409-2.297-10.699-5.774zM15.891 4.55A5.111 5.111 0 0121 9.66c0 2.82-2.29 5.109-5.109 5.109a5.111 5.111 0 01-5.109-5.109c0-2.82 2.29-5.109 5.11-5.109z",
  fill: "#0d5a91"
});

var SvgBespokenIconUserProfile = function SvgBespokenIconUserProfile(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgBespokenIconUserProfile;